"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PillItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _density = require("@site/pattern-library-utils/density");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _splitPanelItem = _interopRequireDefault(require("./split-panel-item"));
/** @module DropDownPillMenuItem */

const LeftPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LeftPanel",
  class: "pc-l1nm1395"
});
const RightPanelContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RightPanelContainer",
  class: "pc-rnsql1s"
});
const RightPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RightPanel",
  class: "pc-r1oapvyb"
});
const IconPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconPanel",
  class: "pc-i6efhhz"
});

/**
 * PillItem
 * @param {Object} props React props
 * @param {number} props.ariaLabel aria label for select element
 * @returns {React.ReactElement} PillItem component
 * @public
 */
function PillItem({
  leftPanelContent,
  rightPanelContent,
  icon
}) {
  const renderSidePanel = side => {
    const content = side === 'left' ? leftPanelContent : rightPanelContent;
    const panel = content.map((row, i) => {
      if (row.type === 'tag') {
        return /*#__PURE__*/_react.default.createElement(_tag.default, {
          dataCy: row.dataCy,
          text: row.text,
          design: row.design || 'highlight',
          size: row.size,
          key: `tag-${i}`
        });
      }
      if (row.type === 'node') {
        return /*#__PURE__*/_react.default.createElement("div", {
          "data-cy": row.dataCy,
          key: `node-${i}`
        }, row.node);
      }
      const {
        text: textContent,
        type,
        dataCy,
        className,
        size,
        ...additionalProps
      } = row;
      return /*#__PURE__*/_react.default.createElement(_text.default.p, (0, _extends2.default)({
        as: type,
        "data-cy": dataCy,
        className: className,
        size: size,
        key: `text-p-${i}`,
        dangerouslySetInnerHTML: {
          __html: _dompurify.default.sanitize(textContent)
        }
      }, additionalProps));
    });
    if (side === 'left') {
      return /*#__PURE__*/_react.default.createElement(LeftPanel, null, panel);
    }
    return /*#__PURE__*/_react.default.createElement(RightPanelContainer, null, /*#__PURE__*/_react.default.createElement(RightPanel, {
      className: "right-panel"
    }, panel), /*#__PURE__*/_react.default.createElement(IconPanel, {
      className: "icon-panel"
    }, icon));
  };
  const leftPanel = renderSidePanel('left');
  const rightPanel = rightPanelContent ? renderSidePanel('right') : null;
  return /*#__PURE__*/_react.default.createElement(_splitPanelItem.default, {
    startAlignedContent: leftPanel,
    endAlignedContent: rightPanel
  });
}
PillItem.propTypes = {
  leftPanelContent: _propTypes.default.array,
  rightPanelContent: _propTypes.default.array,
  icon: _propTypes.default.node
};